import { useCallback, useMemo } from 'react';
import { getPurchaseStatus } from '@/SearchResults/ResultTile/ResultTile.helpers';
import { useUserLocation } from '~/contexts/UserContext';
import { Vehicle } from '~/contracts';

const restrictedStates = ['AR', 'CA', 'CT', 'IL', 'LA', 'MA', 'OR', 'TX', 'UT'];

export function getPriceDropValue(vehicle: Partial<Vehicle>) {
  return vehicle.previousPrice && vehicle.price?.total
    ? vehicle.previousPrice - vehicle.price.total
    : 0;
}

function usePriceDrop() {
  const { state = '' } = useUserLocation();
  const restrictedState = restrictedStates.includes(state);

  const bannerText = useMemo(
    () =>
      restrictedState
        ? 'We’ve updated prices on select vehicles, don’t miss out!'
        : 'We’ve lowered prices to give you more savings. Don’t miss out!',
    [restrictedState]
  );

  const getPriceDrop = useCallback((vehicle: Partial<Vehicle>) => {
    const { isLocked, isOnHold } = getPurchaseStatus(vehicle);
    const priceDrop = getPriceDropValue(vehicle);

    const showPriceDrop = Boolean(
      vehicle.previousPrice && priceDrop > 0 && !isLocked && !isOnHold
    );

    return {
      priceDrop,
      showPriceDrop
    };
  }, []);

  return {
    bannerText,
    getPriceDrop,
    restrictedState
  };
}

export default usePriceDrop;
